import React from "react"
import ParticipantTracks from "~/components/twilio/ParticipantTracks"
import ParticipantInfo from "~/components/twilio/ParticipantInfo"
import { VideoQuality } from "~/components/twilio/VideoProvider"
import type { Participant as ParticipantType } from "@zoom/videosdk"

interface ParticipantProps {
  user: ParticipantType
}

export default function Participant({ user }: ParticipantProps) {
  return (
    <ParticipantInfo user={user}>
      <ParticipantTracks userInfo={user} quality={VideoQuality.Video_360P} />
    </ParticipantInfo>
  )
}
